import { useSelector } from "react-redux";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { selectState as selectStateDashboard } from "Dashboard/dashboard.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { CARNET_PAYROLL_MODULE_NAME } from "Dashboard/scenes/Carnets/domain/CarnetModule";

const TableHeader = () => {
  const { user } = useSelector(selectStateAuth);
  const { provisions } = useSelector(selectStateDashboard);

  return (
    <div
      className={`row ${hasWriteAccessTo(user, CARNET_PAYROLL_MODULE_NAME) ? 'with-payroll' : ''}`}
      style={{ "--carnet-hour-columns": provisions?.activeHourlyRateNames.length } as React.CSSProperties}
    >
      <div className="col capitalize center separator-line">Ime</div>
      <div className="col lowercase center separator-line">info</div>
      {hasWriteAccessTo(user, CARNET_PAYROLL_MODULE_NAME) && (
        <div className="col lowercase center separator-line red-name">zarade</div>
      )}
      <div className="col lowercase right separator-line header-project">projekat</div>
      {provisions?.activeHourlyRateNames.map(hourlyRateName => (
        <div className="col lowercase center separator-line"
          key={hourlyRateName.index}>
          {hourlyRateName.name}
        </div>
      ))}
      <div className="col lowercase center separator-line">datum</div>
      <div className="col lowercase center"></div>
      <div className="col lowercase center separator-line">obrok</div>
      <div className="col lowercase center separator-line">keš obrok</div>
      <div className="col lowercase center separator-line">bolovanje</div>
      <div className="col lowercase center separator-line">odmor</div>
      <div className="col lowercase center separator-line">prijava do</div>
      <div className="col lowercase center separator-line">zdravstveni</div>
      <div className="col lowercase center separator-line">odmora imao</div>
      <div className="col lowercase center">broj telefona</div>
    </div>
  );
};

export default TableHeader;
